var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#CABDFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4889 13.0544C17.376 12.5274 16.624 12.5274 16.5111 13.0544L15.3166 18.6289C15.0202 20.0121 13.7978 21.0003 12.3832 21.0003H11C10.4477 21.0003 10 20.5526 10 20.0003C10 19.448 10.4477 19.0003 11 19.0003H12.3832C12.8547 19.0003 13.2622 18.6709 13.361 18.2098L14.5555 12.6354C15.1201 10.0005 18.8799 10.0004 19.4445 12.6354L22.5111 26.9461C22.624 27.4731 23.376 27.4731 23.4889 26.9461L24.6834 21.3717C24.9798 19.9885 26.2022 19.0003 27.6168 19.0003H29C29.5523 19.0003 30 19.448 30 20.0003C30 20.5526 29.5523 21.0003 29 21.0003H27.6168C27.1453 21.0003 26.7378 21.3297 26.639 21.7907L25.4445 27.3652C24.8799 30.0001 21.1201 30.0001 20.5555 27.3652L17.4889 13.0544Z",
    fill: "#1A1D1F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine);
export default __webpack_public_path__ + "static/media/line.114529891019226901f7fd14f34778e6.svg";
export { ForwardRef as ReactComponent };